module.exports = __webpack_public_path__ + "c01d9d7c1fcf3e146a73f18d3e8d6db9.png";